import { Outlet } from 'react-router-dom';
import DashboardHeader from '../components/dashboard/DashboardHeader';
import Footer from '../components/Footer';

const DashboardLayout = () => (
  <div className="min-h-screen bg-black film-grain flex flex-col">
    <DashboardHeader />
    <main className="flex-1">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-14">
        <Outlet />
      </div>
    </main>
    <Footer />
  </div>
);

export default DashboardLayout;
